//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//物流出库单列表页面
const transportDeliveryOrderList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportDeliveryOrder/list.vue')),
    'transportDeliveryOrderList'
  );
//物流出库单新增页面
const transportDeliveryOrderAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportDeliveryOrder/add.vue')),
    'transportDeliveryOrderAdd'
  );
//物流出库单修改页面
const transportDeliveryOrderEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportDeliveryOrder/edit.vue')),
    'transportDeliveryOrderEdit'
  );
//物流出库单新增页面
const transportDeliveryOrderDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportDeliveryOrder/detail.vue')),
    'transportDeliveryOrderDetail'
  );
// 业务入库单查询
const businessReceiptList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/businessReceipt/businessReceiptList.vue')),
    'businessReceiptList'
  );
// 业务入库单创建
const businessReceiptAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/businessReceipt/add.vue')),
    'businessReceiptAdd'
  );
// 业务入库单编辑、详情
const businessReceiptEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/businessReceipt/edit.vue')),
    'businessReceiptEdit'
  );
//物流入库单查询
const logisticsReceiptList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/logistics/logisticsReceiptList.vue')),
    'logisticsReceiptList'
  );
//物流入库单详情
const logisticsView = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/logistics/logisticsView.vue')),
    'logisticsView'
  );
//物流入库单编辑
const logisticsRevise = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/logistics/logisticsRevise.vue')),
    'logisticsRevise'
  );
//仓储合同列表
const wareHouseContractList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/warehouseContract/list.vue')),
    'wareHouseContractList'
  );
//仓储合同维护
const wareHouseContractAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/warehouseContract/add.vue')),
    'wareHouseContractAdd'
  );
//仓储合同修改
const wareHouseContractEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/warehouseContract/edit.vue')),
    'wareHouseContractEdit'
  );
//仓储合同详情
const wareHouseContractDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/warehouseContract/detail.vue')),
    'wareHouseContractDetail'
  );
//物流运输单查询
const transportOrderList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportOrder/transportOrderList.vue')),
    'transportOrderList'
  );
//物流运输单编辑
const transportOrderEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportOrder/transportOrderEdit.vue')),
    'transportOrderEdit'
  );
//物流运输单创建
const transportOrderAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportOrder/transportOrderAdd.vue')),
    'transportOrderAdd'
  );
//物流合同列表
const logisticsContractList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/logisticsContract/list.vue')),
    'logisticsContractList'
  );
//物流合同维护
const logisticsContractAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/logisticsContract/add.vue')),
    'logisticsContractAdd'
  );
//物流合同修改
const logisticsContractEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/logisticsContract/edit.vue')),
    'logisticsContractEdit'
  );
//物流合同详情
const logisticsContractDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/logisticsContract/detail.vue')),
    'logisticsContractDetail'
  );
//码头作业合同列表
const wharfOperationContractList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/wharfOperationContract/list.vue')),
    'wharfOperationContractList'
  );
//码头作业合同维护
const wharfOperationContractAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/wharfOperationContract/add.vue')),
    'wharfOperationContractAdd'
  );
//码头作业合同修改
const wharfOperationContractEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/wharfOperationContract/edit.vue')),
    'wharfOperationContractEdit'
  );
//码头作业合同详情
const wharfOperationContractDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/wharfOperationContract/detail.vue')),
    'wharfOperationContractDetail'
  );
//运输合同列表
const transportContractList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportContract/list.vue')),
    'transportContractList'
  );
//运输合同维护
const transportContractAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportContract/add.vue')),
    'transportContractAdd'
  );
//运输合同修改
const transportContractEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportContract/edit.vue')),
    'transportContractEdit'
  );
//运输合同详情
const transportContractDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/logisticsCenter/transportContract/detail.vue')),
    'transportContractDetail'
  );

const logisticsRouter = {
  path: '/logistics',
  component: index,
  children: [
    {
      path: 'transportDeliveryOrderList',
      name: 'transportDeliveryOrderList',
      component: transportDeliveryOrderList,
      meta: {
        keepAlive: true,
        title: '物流出库单列表',
      },
    },
    {
      path: 'transportDeliveryOrderAdd',
      name: 'transportDeliveryOrderAdd',
      component: transportDeliveryOrderAdd,
      meta: {
        keepAlive: true,
        title: '物流出库单新增',
      },
    },
    {
      path: 'transportDeliveryOrderEdit',
      name: 'transportDeliveryOrderEdit',
      component: transportDeliveryOrderEdit,
      meta: {
        keepAlive: true,
        title: '物流出库单编辑',
      },
    },
    {
      path: 'transportDeliveryOrderDetail',
      name: 'transportDeliveryOrderDetail',
      component: transportDeliveryOrderDetail,
      meta: {
        keepAlive: true,
        title: '物流出库单详情',
      },
    },
    {
      path: 'businessReceiptList',
      name: 'businessReceiptList',
      component: businessReceiptList,
      meta: {
        keepAlive: true,
        title: '业务入库单查询',
      },
    },
    {
      path: 'businessReceiptAdd',
      name: 'businessReceiptAdd',
      component: businessReceiptAdd,
      meta: {
        keepAlive: true,
        title: '业务入库单创建',
      },
    },
    {
      path: 'businessReceiptEdit',
      name: 'businessReceiptEdit',
      component: businessReceiptEdit,
      meta: {
        keepAlive: true,
        title: '业务入库单编辑',
      },
    },
    {
      path: 'logisticsReceiptList',
      name: 'logisticsReceiptList',
      component: logisticsReceiptList,
      meta: {
        keepAlive: true,
        title: '物流入库单查询',
      },
    },
    {
      path: 'logisticsView',
      name: 'logisticsView',
      component: logisticsView,
      meta: {
        keepAlive: true,
        title: '物流入库单详情',
      },
    },
    {
      path: 'logisticsRevise',
      name: 'logisticsRevise',
      component: logisticsRevise,
      meta: {
        keepAlive: true,
        title: '物流入库单编辑',
      },
    },
    {
      path: 'wareHouseContractList',
      name: 'wareHouseContractList',
      component: wareHouseContractList,
      meta: {
        keepAlive: true,
        title: '仓储合同列表',
      },
    },
    {
      path: 'wareHouseContractAdd',
      name: 'wareHouseContractAdd',
      component: wareHouseContractAdd,
      meta: {
        keepAlive: true,
        title: '仓储合同新增',
      },
    },
    {
      path: 'wareHouseContractEdit',
      name: 'wareHouseContractEdit',
      component: wareHouseContractEdit,
      meta: {
        keepAlive: true,
        title: '仓储合同修改',
      },
    },
    {
      path: 'wareHouseContractDetail',
      name: 'wareHouseContractDetail',
      component: wareHouseContractDetail,
      meta: {
        keepAlive: true,
        title: '仓储合同详情',
      },
    },
    {
      path: 'transportOrderList',
      name: 'transportOrderList',
      component: transportOrderList,
      meta: {
        keepAlive: true,
        title: '物流运输单查询',
      },
    },
    {
      path: 'transportOrderAdd',
      name: 'transportOrderAdd',
      component: transportOrderAdd,
      meta: {
        keepAlive: true,
        title: '物流运输单创建',
      },
    },
    {
      path: 'transportOrderEdit',
      name: 'transportOrderEdit',
      component: transportOrderEdit,
      meta: {
        keepAlive: true,
        title: '物流运输单',
      },
    },
    {
      path: 'logisticsContractList',
      name: 'logisticsContractList',
      component: logisticsContractList,
      meta: {
        keepAlive: true,
        title: '物流合同列表',
      },
    },
    {
      path: 'logisticsContractAdd',
      name: 'logisticsContractAdd',
      component: logisticsContractAdd,
      meta: {
        keepAlive: true,
        title: '物流合同新增',
      },
    },
    {
      path: 'logisticsContractEdit',
      name: 'logisticsContractEdit',
      component: logisticsContractEdit,
      meta: {
        keepAlive: true,
        title: '物流合同修改',
      },
    },
    {
      path: 'logisticsContractDetail',
      name: 'logisticsContractDetail',
      component: logisticsContractDetail,
      meta: {
        keepAlive: true,
        title: '物流合同详情',
      },
    },
    {
      path: 'wharfOperationContractList',
      name: 'wharfOperationContractList',
      component: wharfOperationContractList,
      meta: {
        keepAlive: true,
        title: '码头作业合同列表',
      },
    },
    {
      path: 'wharfOperationContractAdd',
      name: 'wharfOperationContractAdd',
      component: wharfOperationContractAdd,
      meta: {
        keepAlive: true,
        title: '码头作业合同新增',
      },
    },
    {
      path: 'wharfOperationContractEdit',
      name: 'wharfOperationContractEdit',
      component: wharfOperationContractEdit,
      meta: {
        keepAlive: true,
        title: '码头作业合同修改',
      },
    },
    {
      path: 'wharfOperationContractDetail',
      name: 'wharfOperationContractDetail',
      component: wharfOperationContractDetail,
      meta: {
        keepAlive: true,
        title: '码头作业合同详情',
      },
    },
    {
      path: 'transportContractList',
      name: 'transportContractList',
      component: transportContractList,
      meta: {
        keepAlive: true,
        title: '运输合同列表',
      },
    },
    {
      path: 'transportContractAdd',
      name: 'transportContractAdd',
      component: transportContractAdd,
      meta: {
        keepAlive: true,
        title: '运输合同新增',
      },
    },
    {
      path: 'transportContractEdit',
      name: 'transportContractEdit',
      component: transportContractEdit,
      meta: {
        keepAlive: true,
        title: '运输合同修改',
      },
    },
    {
      path: 'transportContractDetail',
      name: 'transportContractDetail',
      component: transportContractDetail,
      meta: {
        keepAlive: true,
        title: '运输合同详情',
      },
    },
  ],
};
export default logisticsRouter;
